export const entityNames = {
  ACCOUNT: 'account',
  APPLICATION: 'application',
  APPLICATION_RESPONSE: 'application_response',
  APPLICATION_DOCUMENT: 'application_document',
  BASE_REQUIREMENT: 'base_requirement',
  BASE_OPTION_SET: 'base_option_set',
  COUNTRY: 'country',
  COUNTRY_SETUP: 'country_setup',
  SURVEY_QUESTION: 'survey_question',
  COUNTRY_TEMPLATE: 'country_template',
  DEPENDENCY: 'dependency',
  INDUSTRY: 'industry',
  LANGUAGE: 'language',
  ORGANISATION_SIZE: 'organisation_size',
  ORGANISATION: 'organisation',
  OCCUPATION: 'occupation',
  OPTION_SET: 'option_set',
  PARTNER: 'partner',
  POSITION: 'position',
  PROMO_CODE: 'promo_code',
  PRICE_RULE: 'price_rule',
  REQUIREMENT: 'requirement',
  SECONDARY_INDUSTRY: 'secondary_industry',
  USER: 'user',
};
